import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReviewRequestSiblings } from '../../../../shared/models/review-requests/review-request-siblings';
import { BaseReviewRequestPropagationModal } from './base-review-request-propagation-modal';
import { AgentActionDirective } from '../../../directives/agent-action.directive';

@Component({
  selector: 'app-create-review-propagation-modal',
  imports: [AgentActionDirective],
  templateUrl: './propagation-modal.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './propagation-modal.scss',
})
export class CreateReviewPropagationModal extends BaseReviewRequestPropagationModal {
  protected execute(): void {
    if (!this.selectedOptionIds || this.selectedOptionIds.length < 1) {
      console.log('No SW Part Numbers selected for creating review siblings');
      return;
    }

    const createReviewRequestSiblings: ReviewRequestSiblings = {
      parentReviewRequestId: this.entityId!,
      siblingReviewRequestTargets: this.mapSelectedSwPartNumbersToTargets(),
    };

    this.reviewRequestApi.createReviewRequestSiblings(createReviewRequestSiblings).subscribe({
      next: () => {
        this.toast.success('Successfully created review siblings for other SW Part Numbers');
        this.closeModal();
      },
      error: (err) => {
        console.log(err);
        this.toast.error('Failed to create review siblings for other SW Part Numbers');
      },
    });
  }
}
